<template>
  <div
    class="container management-page"
    :class="{ collapse: isCollapse }"
  >
    <!-- -->
    <div
      class="left-wrapper"
      v-if="!branchRight"
    >
      <div class="title">
        <i class="icon"></i>
        <span class="info">{{ $t("management.name") }}</span>
      </div>
      <div class="menu-wrapper">
        <el-scrollbar class="auto-height-scrollbar dark">
          <el-menu
            theme="dark"
            :collapse="isCollapse"
            :collapse-btn="true"
            ref="menu"
            :default-active="defaultActive"
            @select="onMenuSelect"
            @click-collapse="handleClickCollapseBtn"
          >
            <!-- :default-active="defaultActive" -->
            <el-menu-item
              v-for="menu in menuList"
              :index="menu.index"
              :key="menu.menuId"
              :icon="menu.icon"
              v-show="menu.show"
            >
              {{ menu.name }}
            </el-menu-item>
          </el-menu>
        </el-scrollbar>
      </div>
      <div class="more-wrapper">
        <span
          class="link-btn"
          :title="$t('management.export_title')"
          @click="exportConfig"
        >
          <i class="export"></i><span v-if="!isCollapse">{{ $t("management.export_title") }}</span></span>
        <span
          class="link-btn"
          :title="$t('management.logout_title')"
          @click="logout"
        >
          <i class="logout"></i><span v-if="!isCollapse">{{ $t("management.logout_title") }}</span></span>
      </div>
    </div>
    <div :class="{ 'full-wrapper': branchRight, 'right-wrapper': !branchRight }">
      <!-- <router-view></router-view> -->
      <component :is="comTypeList[defaultActive]"></component>
    </div>
    <need-modify-pwd></need-modify-pwd>
  </div>
</template>

<script>
import Bus from '../../store/bus'
import needModifyPwd from 'components/need-modify-pwd/need-modify-pwd'
import ApiConfig from 'api/config'
import { autoCloseMenu } from 'utils/mixin'
import widgetManagement from './widget-management/widget-management'
import themeConfiguration from './theme-configuration/theme-configuration'
import navConfiguration from './nav-configuration/nav-configuration'
import menuManagement from './menu-management/menu-management'
import loginConfiguration from './login-configuration/login-configuration'
import homeConfiguration from './home-configuration/home-model'
import dataViewer from './data-view-configuration/data-view-management'
export default {
  name: 'management-page',
  data () {
    return {
      isCollapse: false,
      defaultActive: this.$storage.session.get(`portal-manage-${this.$store.state.userName}`) || 'theme',
      branchRight: false,
      comTypeList: {
        theme: 'themeConfiguration',
        widget: 'widgetManagement',
        nav: 'navConfiguration',
        menu: 'menuManagement',
        login: 'loginConfiguration',
        home: 'homeConfiguration',
        dataView: 'dataViewer'
      },
      menus: [
        {
          index: 'theme',
          menuId: 'isecure_theme_manage',
          key: 'management.theme_name',
          icon: 'iconfont iconnav_theme',
          show: true
        },
        {
          index: 'widget',
          menuId: 'isecure_widget_manage',
          key: 'management.widget_name',
          icon: 'iconfont iconb_ic_bujian',
          show: true
        },
        {
          index: 'menu',
          menuId: 'isecure_menu_manage',
          key: 'management.menu_name',
          icon: 'iconfont iconnav_menu',
          show: process.env.NODE_ENV === 'development'
        },
        {
          index: 'home',
          menuId: 'isecure_index_manage',
          key: 'management.home_name',
          icon: 'iconfont iconnav_home',
          show: true
        },
        {
          index: 'nav',
          menuId: 'isecure_navigation_manage',
          key: 'management.nav_name',
          icon: 'iconfont iconnav_navgation',
          show: true
        },
        {
          index: 'login',
          menuId: 'isecure_login_manage',
          key: 'management.login_name',
          icon: 'iconfont iconnav_login',
          show: true
        },
        {
          index: 'dataView',
          menuId: 'isecure_big_data_manage',
          key: 'management.data_view',
          icon: 'iconfont iconnav_kanbanguanli',
          show: this.$store.state.basicInfo.enableDisplayBoard
        }
      ]
    }
  },
  created () {
    this.judgeBranch()
  },
  computed: {
    menuList () {
      return this.menus.map(item => {
        item.name = this.$t(item.key)
        return item
      })
    }
  },
  methods: {
    onMenuSelect (name) {
      this.defaultActive = name
      return this.$storage.session.set(`portal-manage-${this.$store.state.userName}`, name)
    },
    //  菜单访问次数统计
    navSelect (indexPath) {
      for (let i = 0; i < this.menuList.length; i++) {
        if (indexPath === this.menuList[i].index) {
          //  记录菜单访问次数 by zhangzhitao 2017-07-26 14:30
          //  api.homepage.countMenuVisit(this.menuList[i].menuId)
        }
      }
    },
    //  通过URL地址，判断是自定义首页入口进来的还是门户管理进来的
    judgeBranch () {
      const getQueryString = name => {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        let r = window.location.search.substr(1).match(reg)
        if (r != null) {
          return unescape(r[2])
        }
        return null
      }
      let branch = getQueryString('branch')
      this.branchRight = branch === 'full'
    },
    handleClickCollapseBtn () {
      this.isCollapse = !this.isCollapse
      Bus.$emit('menuCollapse', '')
    },
    logout () {
      this.$confirm(this.$t('common.login_out_tips'), {
        confirmButtonText: this.$t('common.confirmBtn_text'),
        cancelButtonText: this.$t('common.cancelBtn_text'),
        type: 'question'
      }).then(() => {
        //  清空SessionStorage中保存的数据
        // this.$storage.session.clear()
        window.location.href = ApiConfig.logoutSrc
      })
    },
    exportConfig () {
      window.open(ApiConfig.exportConfigSrc)
    }
  },
  components: {
    needModifyPwd,
    widgetManagement,
    themeConfiguration,
    navConfiguration,
    menuManagement,
    loginConfiguration,
    homeConfiguration,
    dataViewer
  },
  mounted () {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
    this._autoCloseMenu()
  },
  mixins: [autoCloseMenu]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/wi-font/iconfont.css";
.management-page.container {
  height: 100%;
  width: 100%;
  position: relative;
  .left-wrapper {
    width: 230px;
    height: 100%;
    box-sizing: border-box;
    //  padding-left: 10px;
    padding-top: 35px;
    position: relative;
    background: #252525;
    /deep/ .el-menu {
      background: transparent;
      .h-icon-menu_leftbar {
        color: rgba(255, 255, 255, 0.4) !important;
      }
      .el-menu-item {
        color: rgba(255, 255, 255, 0.5);
        .el-menu-icon {
          font-size: 16px;
        }
        &.is-active {
          color: rgba(255, 255, 255, 1);
          background: rgba(0, 0, 0, 0.15);
        }
      }
    }
    .title {
      margin-left: 10px;
      .icon {
        width: 40px;
        height: 40px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 15px;
        background-image: url("../../assets/images/management_logo.png");
      }
      .info {
        height: 40px;
        vertical-align: middle;
        line-height: 40px;
        font-size: 24px;
        color: #fff;
      }
    }
    .menu-wrapper {
      //  position: absolute;
      //  bottom: 120px;
      //  top: 100px;
      //  left: 0;
      //  right: 0;
      width: 100%;
      height: calc(~"100% - 220px");
      margin-top: 55px;

      .icon {
        display: inline-block;
        width: 24px;
        height: 16px;
        vertical-align: middle;
        position: relative;
        top: -2px;
        margin-right: 12px;
      }
      /deep/ .el-menu-item {
        .el-menu-icon {
          font-size: 24px;
        }
        .el-menu-item--text {
          margin-left: 7px;
        }
        &.is-active {
          color: rgba(255, 255, 255, 0.9) !important;
        }
      }
    }
    .more-wrapper {
      position: absolute;
      bottom: 28px;
      left: 10px;
      .link-btn {
        margin-bottom: 24px;
        display: block;
        cursor: pointer;
        color: rgba(255, 255, 255, 1);
        font-size: 12px;
        opacity: 0.8;
        i {
          display: inline-block;
          width: 24px;
          height: 24px;
          vertical-align: middle;
          position: relative;
          top: -2px;
          margin-right: 12px;
          &.export {
            background-image: url("../../assets/images/nav_export.png");
          }
          &.logout {
            background-image: url("../../assets/images/nav_sign_out.png");
          }
        }
        &:hover {
          opacity: 1;
        }
      }
    }
  }

  .right-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 230px;
    right: 0;
    overflow: hidden;
    .m-iframe {
      width: 100%;
      height: 100%;
    }
  }
  .full-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .m-iframe {
      width: 100%;
      height: 100%;
    }
  }
  &.collapse {
    .left-wrapper {
      width: 48px;
      padding: 12px 0;
      /deep/ .el-menu-item.is-active {
        font-weight: 100;
      }
      .title {
        margin-left: 4px;
        .icon {
          margin-right: 0;
        }
        .info {
          display: none;
        }
      }
      .menu-wrapper {
        margin-top: 13px;
      }
      .more-wrapper {
        left: 0;
        .link-btn {
          width: 48px;
          height: 40px;
          padding: 12px;
          box-sizing: border-box;
          margin-bottom: 0;
        }
      }
    }
    .right-wrapper {
      left: 48px;
    }
  }
}
</style>
